var map = {
	"./bookmarkModule": "./scripts/store/modules/bookmarkModule.js",
	"./bookmarkModule.js": "./scripts/store/modules/bookmarkModule.js",
	"./cartModule": "./scripts/store/modules/cartModule.js",
	"./cartModule.js": "./scripts/store/modules/cartModule.js",
	"./compareModule": "./scripts/store/modules/compareModule.js",
	"./compareModule.js": "./scripts/store/modules/compareModule.js"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./scripts/store/modules lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;